import apiClient from "./apiClient";

const BASE = "/api/Patient";

// API uses patientID/alternateMobile/dateOfBirth/patientCategory;
// the rest of the app (form, list, redux) uses id/altMobile/dob/category.
const fromApiPatient = (p) => ({
  id: p.patientID,
  opNumber: p.opNumber,
  patientName: p.patientName,
  address: p.address,
  mobileNumber: p.mobileNumber,
  altMobile: p.alternateMobile,
  dob: p.dateOfBirth ? p.dateOfBirth.split("T")[0] : "",
  age: p.age,
  gender: p.gender,
  category: p.patientCategory,
  email: p.email,
  medicalHistory: p.medicalHistory,
  allergies: p.allergies,
  remarks: p.remarks,
  createdDate: p.createdDate,
});

// opNumber is included only when the user supplied one manually (PatientModal's
// "Auto-generate" toggle) — see backend change request: /api/Patient/save must accept
// an optional opNumber and use it verbatim when present, auto-generating as before
// when it's blank/omitted.
const toApiPatient = (f) => ({
  ...(f.opNumber ? { opNumber: f.opNumber } : {}),
  patientName: f.patientName,
  address: f.address,
  mobileNumber: f.mobileNumber,
  alternateMobile: f.altMobile,
  dateOfBirth: f.dob || null,
  gender: f.gender,
  patientCategory: f.category,
  email: f.email,
  medicalHistory: f.medicalHistory,
  allergies: f.allergies,
  remarks: f.remarks,
});

export const getPatients = async (params) => {
  const res = await apiClient.get(`${BASE}/all`, { params });
  return { ...res, data: (res.data || []).map(fromApiPatient) };
};

export const getPatient = async (id) => {
  const res = await apiClient.get(`${BASE}/${id}`);
  return { ...res, data: fromApiPatient(res.data) };
};

// create and update both use /save — include patientID in body for update (0/omit for create)
export const createPatient = async (data) => {
  const res = await apiClient.post(`${BASE}/save`, toApiPatient(data));
  return { ...res, data: fromApiPatient(res.data) };
};

export const updatePatient = async (id, data) => {
  const res = await apiClient.post(`${BASE}/save`, { ...toApiPatient(data), patientID: id });
  return { ...res, data: fromApiPatient(res.data) };
};

export const deletePatient = () => Promise.reject(new Error("Delete not supported by API"));

// search by mobile number (exact match, path param) — returns a single patient, not a list
export const searchPatients = async (query) => {
  const res = await apiClient.get(`${BASE}/search/${encodeURIComponent(query)}`);
  const raw = res.data;
  const arr = Array.isArray(raw) ? raw : raw ? [raw] : [];
  return { ...res, data: arr.map(fromApiPatient) };
};
